import update from 'immutability-helper'
import React from 'react'
import { makeStyles, withStyles} from 'external/material'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import AddIcon from '@mui/icons-material/Add'
import create from 'helpers/command'

const AddButton = withStyles({
  root: {
    flexGrow: 1,
    borderColor: '#1d9be5',
    backgroundColor: '#1d9be5',
    borderRadius: 4,
    boxShadow: 'none',
    color: '#fff',
    '& svg': {
      marginTop: -3
    },
    '& .addIcon': {
      fontSize: '14pt'
    },
    '&:hover': {
      backgroundColor: '#29739f',
      borderColor: '#29739f',
      boxShadow: 'none',
    },
  },
  label: {
    textTransform: 'none'
  }
})(Button)

export default function CreateSection ({onClick, className, caption}) {

  return (
      <AddButton
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        onClick={onClick}
        className={className}
      >
        <AddIcon className="addIcon"/>{caption}
      </AddButton>
  )
}
